export default "__VITE_ASSET__B0DTxAT0__"